module.exports = __webpack_public_path__ + "static/media/health.b72d96b7.svg";